import React from 'react'
import {
  LuCircleCheck,
  LuCirclePlus,
  LuTrash,
  LuTriangleAlert,
} from 'react-icons/lu'

import { Spinner } from '@/components/ui/spinner'
import { ReferralsImportItem } from '@/redux/slices/referralsImportBase'

interface Props {
  importItem: ReferralsImportItem
  removeImportItem: (item: ReferralsImportItem) => void
}

const ImportStatusCell: React.FC<Props> = ({
  importItem,
  removeImportItem,
}) => {
  return (
    <>
      {importItem.importStatus === 'invalid' && (
        <LuTriangleAlert className="text-destructive size-7" />
      )}

      {importItem.importStatus === 'ready' && (
        <LuCirclePlus className="text-info size-7" />
      )}

      {importItem.importStatus === 'processing' && (
        <Spinner className="size-7 text-blue-600" />
      )}
      {importItem.importStatus === 'imported' && (
        <LuCircleCheck className="text-success size-7" />
      )}

      {importItem.importStatus === 'error' && (
        <LuCirclePlus className="text-info size-7" />
      )}

      {importItem.importStatus !== 'imported' &&
        importItem.importStatus !== 'processing' && (
          <>
            <a
              href="#"
              className="hover:text-destructive text-dim absolute"
              style={{ right: '5px', bottom: '5px' }}
              onClick={() => {
                if (confirm('Are you sure you want to remove this item?')) {
                  removeImportItem(importItem)
                }
              }}
            >
              <LuTrash />
            </a>
          </>
        )}
    </>
  )
}

export default ImportStatusCell
